module.exports = __webpack_public_path__ + "img/img-for-psychologist.f9719ef.png";